import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";

function CtaButton({ cta }) {
  const isExternal = /^(https?:|mailto:)/.test(cta.to);
  const cls =
    "inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium px-5 py-3 hover:bg-white transition-colors";
  if (isExternal) {
    return (
      <a href={cta.to} target={cta.to.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className={cls} data-testid="page-cta">
        {cta.label}
        <ArrowUpRight size={15} aria-hidden="true" />
      </a>
    );
  }
  return (
    <Link to={cta.to} className={cls} data-testid="page-cta">
      {cta.label}
      <ArrowUpRight size={15} aria-hidden="true" />
    </Link>
  );
}

export function SectionsPage({
  seoTitle,
  seoDescription,
  path,
  eyebrow,
  title,
  subtitle,
  back,
  sections = [],
  note,
  cta,
  testid = "content-page",
  children,
}) {
  return (
    <PageLayout
      seoTitle={seoTitle}
      seoDescription={seoDescription}
      path={path}
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
      back={back}
      testid={testid}
    >
      {sections.length > 0 && (
        <div className="grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 rounded-2xl overflow-hidden">
          {sections.map((s, i) => (
            <section key={i} className="bg-surface p-7">
              <h2 className="font-display text-lg tracking-tight text-paper mb-2">{s.heading}</h2>
              <p className="text-sm text-fog leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      )}
      {note && <p className="mt-4 text-xs text-fog/70 italic">{note}</p>}
      {children}
      {cta && (
        <div className="mt-10">
          <CtaButton cta={cta} />
        </div>
      )}
    </PageLayout>
  );
}
